module.exports = __webpack_public_path__ + "img/arrow.621d3c26.svg";